<script setup lang="ts">
import type { ISiteIdentifier } from '@/components/rc/common/RcSiteSelect.vue'
import EarningsDashboardSubTable from '@/components/eos/demand-response/EarningsDashboardSubTable.vue'
import useProgramEarningsService, { MISOProgram } from '@/composables/eos/program-earnings-dashboard'
import { toRef } from 'vue'
import { currencyFormatter } from '@/helpers/ep/formatters'

const props = defineProps<{
  programSelected: MISOProgram
  siteSelected: ISiteIdentifier
  monthSelected: number
  yearSelected: number
}>()

const { monthEarningsSummaryQuery } = useProgramEarningsService()

const { data } = monthEarningsSummaryQuery(
  toRef(props, 'siteSelected'),
  toRef(props, 'programSelected'),
  toRef(props, 'yearSelected'),
  toRef(props, 'monthSelected')
)
</script>

<template>
  <el-table v-if="data" :data="data.days">
    <el-table-column type="expand">
      <template #default="{ row }">
        <EarningsDashboardSubTable :program-selected="programSelected" :hours="row.hours" />
      </template>
    </el-table-column>
    <el-table-column label="Date" prop="date" width="140px" />
    <el-table-column
      label="Total Earnings ($)"
      prop="total_earnings_usd"
      width="340px"
      :formatter="currencyFormatter"
    />
    <el-table-column label="Participation Hours (h)" prop="participation_hours" />
    <!-- DA LMP is PR-only -->
    <el-table-column
      v-if="programSelected === MISOProgram.DAPR"
      label="Avg. DA LMP ($/MWh)"
      prop="da_lmp_usd"
      width="180px"
      :formatter="currencyFormatter"
    />
  </el-table>
</template>

<style scoped lang="scss">
:deep(.el-table__expanded-cell) {
  padding: 0;
}

:deep(.el-table__row:has(.el-table__expand-icon--expanded) .el-table__cell) {
  border-bottom: none;
}
</style>
